import { Link } from "@tanstack/react-router";
import type { ReactNode } from "react";

import { can, usePermissions } from "@/auth/permissions";

/**
 * A customer's name that opens the customer, wherever a customer is named —
 * the order page today (#447).
 *
 * To the Customers section with the customer open (`?record=`), the same URL
 * the list opens, so the link can be copied, refreshed and followed cold.
 *
 * Plain text without `customers.view`: the link would land on a page the user
 * cannot open. Hiding it is a courtesy; `GET /api/customers/:id` checks the
 * permission itself.
 */
export function CustomerLink({
  customerId,
  children,
}: {
  customerId: string;
  children: ReactNode;
}) {
  const permissions = usePermissions();
  if (!can(permissions, "customers.view")) return <>{children}</>;

  return (
    <Link
      to="/contacts/customers"
      search={{ record: customerId }}
      className="text-primary-strong font-medium underline-offset-2 hover:underline"
    >
      {children}
    </Link>
  );
}
